function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "740.2341918945312 527.8536376953125 254.59991455078125 310.79998779296875",
    width: 254.59991455078125,
    height: 310.79998779296875,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 14.63415813446045, 5.853658199310303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1.1368683772161603e-13, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C06735",
    d: "M889.7,547.4c-3.7-9.6-13.4-25-36.7-25.4c-23.4,0.4-33,15.8-36.7,25.4H889.7z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C06735",
    d: "M891.8,554.9h-25.3H814c-32.2,1.1-88.4,9.4-88.4,9.4v23.3h127.3h127.3v-23.3 C980.2,564.3,924.1,556,891.8,554.9z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C06735",
    d: "M852.9,597.1H737.3l31.1,235.7h84.5h84.5l31.1-235.7H852.9z M808.5,818.9c-3.1,0.3-5.8-1.9-6.1-4.9 l-21.9-195.5c-0.3-3.1,1.9-5.8,4.9-6.1c3-0.3,5.8,1.9,6.1,4.9l21.9,195.5C813.7,815.8,811.5,818.5,808.5,818.9z M858.5,813.3 c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6V616.6c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6V813.3z M928.2,618.4 l-21.9,195.5c-0.3,3.1-3.1,5.2-6.1,4.9c-3.1-0.3-5.2-3.1-4.9-6.1l21.9-195.5c0.3-3.1,3.1-5.2,6.1-4.9 C926.4,612.6,928.6,615.4,928.2,618.4z",
    style: {
      fill: "rgb(204, 204, 204)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete2.f13dd81e7993634b829ea2c2f2464a3b.svg";
export { ForwardRef as ReactComponent };